const highlighterConfig = {
  id: 'highlighter',
  label: 'Highlighter',
  icon: 'highlighter',
  colors: [
    { name: 'Moon White', hex: '#F0EEE8' },
    { name: 'Pearl White', hex: '#FFF3C4' },
    { name: 'Platinum', hex: '#E8E8F0' },
    { name: 'Icy Pink', hex: '#FFD6E8' },
    { name: 'Champagne', hex: '#FCEAB0' },
    { name: 'Soft Peach', hex: '#FFE2BD' },
    { name: 'Coral Glow', hex: '#FCCAB0' },
    { name: 'Rose Gold', hex: '#F8DFAE' },
    { name: 'Warm Gold', hex: '#F6E2A6' },
    { name: 'Rich Gold', hex: '#EED89A' },
    { name: 'Sunrise Gold', hex: '#F0D090' },
    { name: 'Bronze Glow', hex: '#E8C89A' },
    { name: 'Copper Glow', hex: '#C9956C' },
    { name: 'Amber Bronze', hex: '#B87848' },
    { name: 'Deep Gold', hex: '#C4A05A' },
    { name: 'Warm Cognac', hex: '#A86B45' },
  ],
  finishTypes: [
    { id: 'shimmer', name: 'Shimmer' },
    { id: 'dewy', name: 'Dewy' },
    { id: 'satin', name: 'Satin' },
    { id: 'matte', name: 'Matte' },
  ],
  intensityDefault: 50,
  intensityMin: 0,
  intensityMax: 100,
};

export default highlighterConfig;
